import type { IActiveTime } from '../../../../../models/active-time.model';
import { Weekday } from '../../../../../models/weekday.enum';

const orderedDays = [Weekday.Monday, Weekday.Tuesday, Weekday.Wednesday, Weekday.Thursday, Weekday.Friday, Weekday.Saturday, Weekday.Sunday] as const;

export class AffectedPeriodsFactHelper {
  public static getFormattedPeriods(activeTimes: IActiveTime[] | undefined): string[] {
    return (activeTimes ?? []).map((activeTime) => this.formatPeriod(activeTime)).filter((period): period is string => Boolean(period));
  }

  private static formatPeriod(activeTime: IActiveTime): string | null {
    if (!activeTime.from || !activeTime.to || !activeTime.days?.length) return null;

    const normalizedDays = orderedDays.filter((day) => activeTime.days.includes(day));
    if (normalizedDays.length === 0) return null;

    const formattedDays = this.areConsecutive(normalizedDays) ? this.formatConsecutiveDays(normalizedDays) : normalizedDays.map((day) => this.getLocalizedDayLabel(day)).join(', ');

    return `${formattedDays} kl ${activeTime.from}-${activeTime.to}`;
  }

  private static areConsecutive(days: Weekday[]): boolean {
    return days.every((day, currentIndex) => currentIndex === 0 || day - days[currentIndex - 1] === 1);
  }

  private static formatConsecutiveDays(days: Weekday[]): string {
    if (days.length === 1) return this.getLocalizedDayLabel(days[0]);

    return `${this.getLocalizedDayLabel(days[0])}-${this.getLocalizedDayLabel(days[days.length - 1])}`;
  }

  private static getLocalizedDayLabel(day: Weekday): string {
    switch (day) {
      case Weekday.Monday:
        return 'mån';
      case Weekday.Tuesday:
        return 'tis';
      case Weekday.Wednesday:
        return 'ons';
      case Weekday.Thursday:
        return 'tors';
      case Weekday.Friday:
        return 'fre';
      case Weekday.Saturday:
        return 'lör';
      case Weekday.Sunday:
        return 'sön';
    }
  }
}
